import React, { Component } from "react";
import { IconTextInput, CheckboxInput } from "../../../../forms/components";

class CreateMerchantGatewayRatesTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			baseRate: props.baseRate[props?.gateway][props?.currency],
			paymentTypes: Object.keys(props.MDRTypes),
			enable: props.enable[props.gateway][props.currency],
		};
	}

	componentDidUpdate(prevProps) {
		const { baseRate, gateway, currency, enable } = this.props;
		if (
			JSON.stringify(prevProps.baseRate) !== JSON.stringify(baseRate) &&
			baseRate[gateway]
		)
			this.setState({ baseRate: baseRate[gateway][currency] });

		if (JSON.stringify(prevProps.enable) !== JSON.stringify(enable))
			this.setState({ enable: enable[gateway][currency] });
	}

	setGatewayRates = (gateway, currency) => {
		const ratesEnabled =
			Object.values(this.state.enable).filter((i) => i === true).length > 0;

		this.props.setGatewayRates({ gateway, currency }, !ratesEnabled);
	};

	render() {
		const { MDRTypes, gateway, currency, enableRate } = this.props;
		const { baseRate, paymentTypes, enable } = this.state;

		let ratesEnabled = false;
		if (enable) {
			ratesEnabled = Object.values(enable).filter((i) => i === true).length > 0;
		}

		return (
			<>
				<div>
					<div className="uk-flex uk-flex-middle">
						<span>Enable</span>
						<div className="uk-margin-left">
							<label className="uk-form-label">
								<input
									className="uk-checkbox uk-margin-right"
									type="checkbox"
									checked={ratesEnabled}
									onChange={() => this.setGatewayRates(gateway, currency)}
								/>
							</label>
						</div>
					</div>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</div>
				<div className="new-merchant-rate-table uk-overflow-auto uk-margin-bottom">
					{baseRate && (
						<table className="uk-table uk-table-striped uk-table-middle">
							<thead>
								<tr>
									<th>Payment Type</th>
									<th>Local Card</th>
									<th>Overseas Card</th>
									<th className="uk-width-1-6">Enabled</th>
								</tr>
							</thead>
							<tbody>
								{paymentTypes
									.filter((i) => !i.isAdhoc)
									.map((type) => {
										let prefix = `${gateway}.${currency}.${type}`;
										let paymentRate = baseRate[type];

										if (paymentRate) {
											let isDisabled = enable ? !enable[type] : false;
											return (
												<tr key={`${prefix}-rate`}>
													<td>
														<img
															className="uk-img"
															src={`data:image/*;base64,${MDRTypes[type].image}`}
															width="35"
														/>
														<span className="uk-margin-small-left">
															{MDRTypes[type].label}
														</span>
													</td>
													<td>
														<IconTextInput
															id={`rates.${prefix}.local.percent`}
															name={`rates.${prefix}.local.percent`}
															icon="fa-solid-percent; ratio: 0.5"
															iconFlip={true}
															type="number"
															step=".01"
															min={paymentRate.local.percent}
															placeholder="Local"
															disabled={isDisabled}
														/>
													</td>
													<td>
														<IconTextInput
															id={`rates.${prefix}.overseas.percent`}
															name={`rates.${prefix}.overseas.percent`}
															icon="fa-solid-percent; ratio: 0.7"
															iconFlip={true}
															type="number"
															step=".01"
															min={paymentRate.overseas.percent}
															placeholder="Overseas"
															disabled={isDisabled}
														/>
													</td>
													<td className="uk-width-1-5 uk-text-center">
														<CheckboxInput
															id={`enable.${prefix}`}
															name={`enable.${prefix}`}
															handleChange={(value) =>
																enableRate(prefix, value)
															}
														/>
													</td>
												</tr>
											);
										}
									})}
							</tbody>
						</table>
					)}
				</div>
			</>
		);
	}
}

export default CreateMerchantGatewayRatesTable;
